// extracted by mini-css-extract-plugin
module.exports = {"title":"icon-list-section-module--title--2sHtU","container":"icon-list-section-module--container--1mU2R","iconList":"icon-list-section-module--iconList--VVYIH"};